<template>
    <div class="menuModule autoOverflow hiddenScrollbar" data-name="金刚区">

        <div style="padding: 16px 0 0;">
            <div id="menuContainer" class="hiddenScrollbar"
                 style="justify-content: inherit; align-items: stretch; overflow: auto"
                    @scroll="onScroll" @load="onScroll">
                <ul class="menu noListStyle clearfix noPadding noMargin font12r">
                    <li class="item fWeight500" v-for="dataItem in dataList" :key="dataItem.id">

                        <div class="link fWeight500" @click="viewDatumCategory(dataItem.id)">
                            <div>
                                <img :src="dataItem.icon"/>
                            </div>
                            <div>{{dataItem.title}}</div>
                        </div>
                    </li>
                </ul>
            </div>

            <div class="alignCenter paddingV8" v-show="status === 'loading'">
                <i class="icon spinner-loader"></i>
            </div>

<!--            <div class="alignCenter" style="height: 4px;">-->
<!--                <div class="indicator alignT">-->
<!--                    <div class="bar" :style="'width: ' + (indicator.bar.width * 100) + '%; margin-left:' +-->
<!--                        (indicator.bar.left * 100) + '%;'"></div>-->
<!--                </div>-->
<!--            </div>-->

            <div class="font14r grey999" v-if="status==='error'">数据加载失败</div>

        </div>


    </div>
</template>

<script>

import generalCmpPart from '@comp/part/generalCmpPart';

// data
import skipTypeEnum from '@/data/skipTypeEnum';
import categoryApi from '@/api/category';

// utils
import domHelper        from '@/util/domHelper';
import consoleHelper    from "@/util/consoleHelper";
import appHelper        from "@/util/appHelper";
import deviceHelper     from "@/util/deviceHelper";
import browserHelper    from "@/util/browserHelper";
import datumApi from "@api/datum";

const config = {

};

export default {
    name: "tagMenuModule",
    extends : generalCmpPart,
    components : {
        // slider, slideritem
    },
    data () {
        return {
            // apiConfig : config.apiConfig,
            enableDataList : true,
            scrollToLoadNextPage : false,
            pageSize : 50,
            sliderOptions: {
                currentPage: 0,
                pagination : false,
                autoplay : '5000',
                loop : true,
                // preventDocumentMove:true
            },
            indicator : {
                bar : {
                    width: '0',
                    left: '0'
                }
            },
            skipTypeEnum : skipTypeEnum,
            browserHelper : browserHelper
        }
    },
    methods : {
        onSlide : function (event) {
            this.currentPage = event.currentPage;
        },
        onScroll : function (event) {

            // type null|HTMLElement
            let target = null;

            if (event)
            {
                target = event.currentTarget;
            }
            else
            {
                target = domHelper.getElement('menuContainer');
            }
            let children = target.childNodes[0];
            this.indicator.bar.width    = target.offsetWidth / children.offsetWidth;
            this.indicator.bar.left     = target.scrollLeft / children.offsetWidth;
        },
        getAppId(dataItem) {
            let options = {};
            try {
                options = JSON.parse(dataItem.link);
            }
            catch (e)
            {

            }
            return options.appId;
        },
        getPath(dataItem) {
            let options = {};
            try {
                options = JSON.parse(dataItem.link);
            }
            catch (e)
            {

            }
            return options.path;
        },
        onLaunchWeApp(e) {
            consoleHelper.log('launch weapp success', e);
        },
        onLaunchWeAppError(e) {
            consoleHelper.log('launch weapp fail', e.detail);
        },
        onClickWeAppLink(e) {
            if (deviceHelper.isBrowser && !browserHelper.isWechat)
            {
                appHelper.showHint('只能在微信里面打开小程序');
            }
        },
        launchWeApp(event) {
            let target = event.currentTarget;

            let parentNode = target.parentNode;

            let wxOpenLaunchWeappTag = parentNode.querySelector('wx-open-launch-weapp');

            if (!wxOpenLaunchWeappTag)
            {
                consoleHelper.logError('wxOpenLaunchWeappTag not found');
                return;
            }

            let clickEvent = new Event('click');

            if (typeof (window.dispatchEvent) !== 'undefined') {    // for standard
                wxOpenLaunchWeappTag.dispatchEvent(clickEvent);
            }
            else if (typeof (window.fireEvent) !== 'undefined') {   // for old version IE
                wxOpenLaunchWeappTag.fireEvent(clickEvent);
            }
        },
        viewDatumCategory(id)
        {
            appHelper.redirect('/datum/' + id);
        }
    },
    mounted() {
        // categoryApi.loadList('DATUM', (list) => {
        //     this.dataList = list;
        // });
        datumApi.getTagList((result) => {
            // this.dataList = result.data.lengthwaysTagList.splice(0, 8);
            this.dataList = result.data.lengthwaysTagList;
        });
    },
    updated() {
        this.onScroll();
    }
}
</script>

<style lang="scss" scoped>
.menuModule {
    .menu {
    }
    .item {
        position: relative;
        float: left;
        /*width: 18.66vw;*/

        /* 4 columns */
        width: 93.75px;
        width: 25vw;

        /* 5 columns */
        //width: 75px;
        //width: 20vw;

        /*height: 42px;*/
        /*height: 12.26vw;*/
        margin-bottom: 16px;
        text-align: center;

        .link, .link:visited {
            color: hsla(0, 0%, 20%, 1);
            display: block;
            width: 100%;
        }

        img {
            /*display: block;*/
            /*width: 100%;*/
            /*height: 13.866vw;*/
            //width: 12.266vw;
            //height: 11.2vw;
            width: 46px;
            height: 42px;
            overflow: hidden;
            margin-bottom: 2px;
            border-radius: 16px;
        }
    }
    .indicator {
        width: 32px;
        height: 4px;
        background: #F2F3F8;
        border-radius: 2px;
        .bar {
            height: 100%;
            border-radius: 2px;
            background: #FFA724;
        }
    }
    .clickLayer {
        //display: block;
        //position: absolute;
        //top: 0;
        //left: 0;
        //width: 100%;
        //height: 100%;
        //
        //border: none;
        //background: transparent;
    }
}
</style>
